import React, { useRef, useState, useEffect } from 'react'

import MapMarker from './MapMarker'
import MapAttribution from './MapAttribution'

const x = 17, y = 11

const MapContent = props => {
  const wrapper = useRef()
  const mapBody = useRef()
  const resizeTimeout = useRef()
  const [ maxWidth, setMaxWidth ] = useState('auto')
  const [ offset, setOffset ] = useState([ 0, 0 ])

  const handleResize = () =>
    setMaxWidth((mapBody.current.offsetHeight * (x / y)) + 'px')

  const debounceHandleResize = () => {
    clearTimeout(resizeTimeout.current)
    resizeTimeout.current = setTimeout(handleResize, 66)
  }

  useEffect(() => {
    handleResize()
    addEventListener('resize', debounceHandleResize)
    return () => removeEventListener('resize', debounceHandleResize)
  }, [])

  const bringMarkerIntoView = () => {
    if (!props.activeMarker) return setOffset([ 0, 0 ])

    const padding = 16
    const popover = wrapper.current
    .querySelector('.map-marker-active .map-marker-popover')
    const popoverRect = popover.getBoundingClientRect()
    const wrapperRect = wrapper.current.getBoundingClientRect()

    setOffset(([ offsetLeft, offsetTop ]) => [
      Math.max(0, wrapperRect.left + offsetLeft - popoverRect.left + padding) ||
      Math.min(0, (wrapperRect.left + offsetLeft + wrapperRect.width) -
        (popoverRect.left + popoverRect.width + padding)
      ),
      Math.max(0, wrapperRect.top + offsetTop - popoverRect.top + padding) ||
      Math.min(0, (wrapperRect.top + offsetTop + wrapperRect.height) -
        (popoverRect.top + popoverRect.height + padding)
      ),
    ])
  }

  useEffect(() => { setTimeout(bringMarkerIntoView, 90) },
    [ props.activeMarker, maxWidth ])

  return (
    <div className="map-wrapper flex-fill d-flex pt-4" ref={wrapper}>
      <div
        className="position-absolute text-primary ml-5 mt-n2 d-md-none"
        style={{ cursor: 'pointer' }}
        onClick={() => props.setShowNav(showNav => !showNav)}
        aria-hidden="true"
      >Menu</div>

      <div
        className="map-wrapper-inner flex-fill d-flex flex-column"
        style={{ transform: `translate(${offset.map(x => `${x}px`).join()})` }}
      >
        <div className="map-body flex-fill" ref={mapBody}>
          <div className="map" style={{ maxWidth }}>
            <div className="map-content" style={{ paddingTop: `${y / x * 100}%` }}>
              {props.projects.map(project =>
                <MapMarker
                  key={project.slug}
                  project={project}
                  projectPanel={props.projectPanel}
                  openProjectPanel={props.openProjectPanel}
                  activeMarker={props.activeMarker}
                  setActiveMarker={props.setActiveMarker}
                />
              )}
            </div>
          </div>
        </div>

        <div className="map-footer">
          <ul className="map-legend h6 text-uppercase mx-4 mb-4 mb-md-5 mx-md-5 mx-lg-4 mb-lg-4 mx-xl-5 mb-xl-5">
            <li className="text-home"><span>Home</span></li>
            <li className="text-garden"><span>Garden</span></li>
            <li className="text-community-center"><span>Community Center</span></li>
          </ul>
        </div>
      </div>

      <MapAttribution />
    </div>
  )
}

export default MapContent
